import React, { useEffect, useState } from "react";
import { Loader2, Share2, RefreshCw } from "lucide-react";
import { api } from "../lib/api";
import TrafficReportView from "./TrafficReportView";
import TrafficShareModal from "./TrafficShareModal";

export default function AdminTrafficTab() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [shareOpen, setShareOpen] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/admin/traffic");
            setData(data);
        } finally { setLoading(false); }
    };
    useEffect(() => { load(); }, []);

    if (loading) {
        return <div className="flex items-center justify-center py-12" data-testid="traffic-loading"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
    }
    if (!data) {
        return <div className="ll-card text-sm text-muted-foreground">No traffic yet. Page visits will appear here as soon as someone lands on the site.</div>;
    }

    return (
        <div className="space-y-4" data-testid="admin-traffic-tab">
            {/* Action bar — Refresh + Share */}
            <div className="flex items-center justify-end gap-2 flex-wrap print:hidden">
                <button type="button" onClick={load}
                        className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-border hover:bg-accent"
                        data-testid="traffic-refresh">
                    <RefreshCw className="h-3.5 w-3.5" /> Refresh
                </button>
                <button type="button" onClick={() => setShareOpen(true)}
                        className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"
                        data-testid="traffic-share-btn">
                    <Share2 className="h-3.5 w-3.5" /> Share this report
                </button>
            </div>

            <TrafficReportView data={data} />

            <TrafficShareModal open={shareOpen} onClose={() => setShareOpen(false)} />
        </div>
    );
}
